module.exports = __webpack_public_path__ + "static/media/7process-working.74b7505b.png";